//下部広告が表示されない時用のスペーシングBOX
//mui v5 完了

import React from "react"
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

const SpacingBox = () => {
    const theme = useTheme()
    return (
        <Box sx={{
            display: "none",
            [theme.breakpoints.down('xl')]: {
                display: 'flex',
                height: "100px"
            },
        }}>
        </Box>
    )
}

export default SpacingBox